import * as api from "../api";
import * as types from "../constants/action-types";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import { db } from "../firebase";

/********** Product Action ********/
// recieve products
export const receiveProducts = (products) => ({
  type: types.RECEIVE_PRODUCTS,
  products,
});
//recieve Categories
export const receiveCategories = (categories) => ({
  type: types.RECEIVE_CATEGORIES,
  categories,
});
// recieve Industries
export const receiveIndustries = (industries) => ({
  type: types.RECEIVE_INDUSTRIES,
  industries,
});

//recieve orders
export const receiveOrders = (orders) => ({
  type: types.RECEIVE_ORDERS,
  orders,
});

// refresh local storage

export const refreshUnSafe = (current) => ({
  type: types.REFRESH_STORE,
  current,
});

export const refreshStore = (current) => (dispatch) => {
  dispatch(refreshUnSafe(current));
};

// get all products
export const getAllProducts = () => (dispatch) => {
  api.getProducts().then((products) => {
    dispatch(receiveProducts(products));
    return products;
  });
};

export const getAllFirebaseProducts = () => (dispatch) => {
  debugger;
  db.collection("Products").onSnapshot((snapshot) => {
    let products = [];

    for (let p = 0; p < (snapshot.docs || []).length; p++) {
      debugger;
      var doc = snapshot.docs[p].data();
      var id = snapshot.docs[p].id;
      products.push({
        id: id,
        name: doc.title,
        price: doc.price,
        platform: doc.techs,
        // pictures: [...doc.otherImages],
        pictures: [
          "assets/images/products/single/fullwidth/1-big.jpg",
          "assets/images/products/single/fullwidth/2-big.jpg",
        ],
        smPictures: [
          "assets/images/products/elements/product-1-1-300x300.jpg",
          "assets/images/products/elements/product-1-2-300x300.jpg",
          "assets/images/products/elements/product-1-3-300x300.jpg",
          "assets/images/products/elements/product-1-4-300x300.jpg",
        ],
        shortDesc: doc.description,
        category: [doc.category],
        industry: [doc.industry],
        brands: ["UGG"],
        top: true,
        ratings: 4,
        reviews: 1,
        stock: 10,
      });
    }
    dispatch(receiveProducts(products));
    return products;
  });
};

export const getAllFirebaseCategories = () => (dispatch) => {
  db.collection("Category").onSnapshot((snapshot) => {
    // debugger
    //let products = snapshot.docs.map(doc=> doc.data());
    let categories = [];
    for (let k = 0; k < (snapshot.docs || []).length; k++) {
      var doc = snapshot.docs[k].data();
      var id = snapshot.docs[k].id;
      categories.push({
        id: id,
        name: doc.title,
        price: 76,
        pictures: [
          "assets/images/products/single/fullwidth/1-big.jpg",
          "assets/images/products/single/fullwidth/2-big.jpg",
          // doc.image,
          // doc.image
        ],
        smPictures: [
          // "assets/images/products/elements/product-1-1-300x300.jpg",
          // "assets/images/products/elements/product-1-2-300x300.jpg",
          // "assets/images/products/elements/product-1-3-300x300.jpg",
          // "assets/images/products/elements/product-1-4-300x300.jpg"
          doc.image,
        ],
        shortDesc: doc.description,
        category: ["Women"],
        brands: ["UGG"],
        top: true,
        ratings: 4,
        reviews: 1,
        stock: 10,
      });
    }
    dispatch(receiveCategories(categories));
    return categories;
  });
};
// get all Industry Products
export const getAllFirebaseIndustry = () => (dispatch) => {
  db.collection("Industry").onSnapshot((snapshot) => {
    // debugger

    let industries = [];
    for (let k = 0; k < (snapshot.docs || []).length; k++) {
      var doc = snapshot.docs[k].data();
      var id = snapshot.docs[k].id;
      industries.push({
        id: id,
        name: doc.title,
        price: 76,
        pictures: [
          "assets/images/products/single/fullwidth/1-big.jpg",
          "assets/images/products/single/fullwidth/2-big.jpg",
          // doc.image,
          // doc.image
        ],
        smPictures: [
          // "assets/images/products/elements/product-1-1-300x300.jpg",
          // "assets/images/products/elements/product-1-2-300x300.jpg",
          // "assets/images/products/elements/product-1-3-300x300.jpg",
          // "assets/images/products/elements/product-1-4-300x300.jpg"
          doc.image,
        ],
        shortDesc: doc.description,
        category: ["Women"],
        brands: ["UGG"],
        top: true,
        ratings: 4,
        reviews: 1,
        stock: 10,
      });
    }
    dispatch(receiveIndustries(industries));
    return industries;
  });
};

// get all order Products//
export const getAllFirebaseOrders = () => (dispatch) => {
  db.collection("Order").onSnapshot((snapshot) => {
    // debugger
    //let products = snapshot.docs.map(doc=> doc.data());
    let orders = [];
    for (let l = 0; l < (snapshot.docs || []).length; l++) {
      var doc = snapshot.docs[l].data();
      console.log(doc);
      var id = snapshot.docs[l].id;
      var orderArray = doc.products;
      let orderName = [];
      for (let k = 0; k < orderArray.length; k++) {
        orderName.push(orderArray[k].productName);
      }
      orders.push({
        id: id,
        username: doc.firstName + " " + doc.lastName,
        userId: doc.userId,
        productName: orderName,

        pictures: [
          "assets/images/products/single/fullwidth/1-big.jpg",
          "assets/images/products/single/fullwidth/2-big.jpg",
          // doc.image,
          // doc.image
        ],
        // "smPictures": [
        //     // "assets/images/products/elements/product-1-1-300x300.jpg",
        //     // "assets/images/products/elements/product-1-2-300x300.jpg",
        //     // "assets/images/products/elements/product-1-3-300x300.jpg",
        //     // "assets/images/products/elements/product-1-4-300x300.jpg"
        //     doc.image
        // ],
        email: doc.email,
        phoneNo: doc.phoneNo,
        category: ["Women"],
        brands: ["UGG"],
        top: true,
        ratings: 4,
        reviews: 1,
        stock: 10,
      });
    }
    dispatch(receiveOrders(orders));
    return orders;
  });
};

// Vishal - Action to load from the api
export const getAdminProducts = () => (dispatch) => {
  api.getProducts().then((adminProducts) => {
    const products = [adminProducts[0], adminProducts[1]];
    dispatch(receiveProducts(products));
    return products;
  });
};

/*********** Modal related Action **********/
// display quickview
export const showQuickViewModal = (productId) => ({
  type: types.SHOW_QUICKVIEW,
  productId,
});

// close quickview modal
export const closeQuickViewModal = () => ({
  type: types.CLOSE_QUICKVIEW,
});

// Show Video & Login modal
export const showModal = (modal) => ({
  type: types.SHOW_MODAL,
  modal: modal,
});

// close Video & Login modal
export const closeModal = (modal) => ({
  type: types.CLOSE_MODAL,
  modal: modal,
});

// don't show Newsletter modal
export const removeNewsletterMdoal = (modal) => ({
  type: types.REMOVE_NEWSLETTER,
});

/************ Cart Action **************/
// add item to cart
export const addToCart = (product, qty) => (dispatch) => {
  // debugger
  toast.success("Item Added to Cart");
  dispatch(addToCartUnsafe(product, qty));
};

// add item platform to cart
// export const addPlatformToCart=(product,platform)=>(dispatch)=>{

//     dispatch(addPlatformToCartUnsafe(product,platform));
// }

// add item to cart : typical action
export const addToCartUnsafe = (product, qty) => ({
  type: types.ADD_TO_CART,
  product,
  qty,
});
// add platform to cart :typical action

// export const addPlatformToCartUnsafe=(product,platform)=>({
//     type:types.ADD_PLATFORM_TO_CART,
//     product,
//     platform
// })

// remove item from wishlist
export const removeFromWishlist = (productId) => (dispatch) => {
  toast.error("Item removed from Wishlist");
  dispatch({
    type: types.REMOVE_FROM_WISHLIST,
    productId,
  });
};

// add item to cart from wishlist
export const addToCartFromWishlist = (product, qty) => (dispatch) => {
  toast.success("Item added to Cart");

  dispatch({
    type: types.REMOVE_FROM_WISHLIST,
    productId: product.id,
  });

  dispatch(addToCartUnsafe(product, qty));
};

// remove item from cart
export const removeFromCart = (productId) => (dispatch) => {
  toast.error("Item removed from Cart");

  dispatch({
    type: types.REMOVE_FROM_CART,
    productId,
  });
};

// change item's qty
export const changeQty = (productId, qty) => ({
  type: types.CHANGE_QTY,
  productId,
  qty,
});

// change shipping method
export const changeShipping = (shipping) => ({
  type: types.CHANGE_SHIPPING,
  shipping,
});

/*********** Wishlist Action *********/

// add item to wishlist
export const toggleWishlist = (product) => (dispatch) => {
  dispatch(toggleWishlistUnsafe(product));
};

// add item to wishlist : typical action
export const toggleWishlistUnsafe = (product) => ({
  type: types.TOGGLE_WISHLIST,
  product,
});

/************* Compare Action ***********/
// add to comparelist
export const addToCompare = (product) => (dispatch) => {
  toast.success("Item added to Compare");
  dispatch(addToCompareUnsafe(product));
};

export const addToCompareUnsafe = (product) => ({
  type: types.ADD_TO_COMPARE,
  product,
});

// remove all items from cartlist
export const removeFromCompare = (productId) => (dispatch) => {
  toast.success("Compare item removed");
  dispatch(removeFromCompareUnsafe(productId));
};

export const removeFromCompareUnsafe = (productId) => ({
  type: types.REMOVE_FROM_COMPARE,
  productId,
});

// reset cartlist with intialstate
export const resetCompare = () => ({
  type: types.RESET_COMPARE,
});

/************** Filter Action ***********/

// set order to sort
export const filterSort = (sortBy) => (dispatch) => {
  dispatch({
    type: types.SORT_BY,
    sortBy,
  });
};

export const setUserName = (setUserName) => (dispatch) => {
  debugger;
  dispatch({
    type: types.SET_USERNAME,
    setUserName,
  });
};
export const filterProductByName = (searchTerm) => (dispatch) => {
  dispatch({
    type: types.SEARCH_BY_NAME,
    searchTerm,
  });
};

// set price range to get suitable products
export const filterPrice = (range) => (dispatch) => {
  dispatch({
    type: types.PRICE_FILTER,
    range,
  });
};

// add/remove category to get suitable products
export const toggleCategoryFilter = (category) => (dispatch) => {
  dispatch({
    type: types.CATEGORY_FILTER,
    category,
  });
};
// add/remove industry filter to get suitable products
export const toggleIndustryFilter = (industry) => (dispatch) => {
  dispatch({
    type: types.INDUSTRY_FILTER,
    industry,
  });
};

// add/remove product size to get suitable products
export const toggleSizeFilter = (size) => (dispatch) => {
  dispatch({
    type: types.SIZE_FILTER,
    size,
  });
};

// add/remove color to get suitable products
export const toggleColorFilter = (color) => (dispatch) => {
  dispatch({
    type: types.COLOR_FILTER,
    color,
  });
};

//add/remove platform to get suitable platform
export const togglePlatformFilter = (platform) => (dispatch) => {
  dispatch({
    type: types.PLATFORM_FILTER,
    platform,
  });
};

// add/remove brand to get suitable products
export const toggleBrandFilter = (brand) => (dispatch) => {
  dispatch({
    type: types.BRAND_FILTER,
    brand,
  });
};

// add/remove rating to get suitable products
export const toggleRatingFilter = (rating) => (dispatch) => {
  dispatch({
    type: types.RATING_FILTER,
    rating,
  });
};

// reset filter with intialstate
export const resetFilter = () => (dispatch) => {
  dispatch({
    type: types.RESET_FILTER,
  });
};

/************** Newsletter Modal ************/

// hide newsletter modal in homepage
export const hideNewsletterModal = () => ({
  type: types.HIDE_NEWSLETTER_MODAL,
});

/**************UserLogin**********/
export const setCurrentUser = (user) => ({
  type: types.SET_CURRENT_USER,
  payload: user,
});

// for search Term Product fetch
export const setSearchTerm = (search) => ({
  type: types.SET_SEARCH_TERM,
  payload: search,
});
